export default __webpack_public_path__ + "static/media/orangepiggy.ac45d026.svg";